import AppLayout from '@/layout/AppLayout.vue'
import { fuelStationRoute } from '@/modules/fuel-station/fuel_station.routes.ts'
import { createRouter, createWebHistory } from 'vue-router'
import { dashboardRoute } from '@/modules/dashboard/dashboard.routes.ts'
import { staffRoute } from '@/modules/staff/staff.routes.ts'
import { faqRoute } from '@/modules/faq/faq.routes.ts'
import { fuelTypeRoute } from '@/modules/fuel-type/fuel-type.routes.ts'
import { fuelStationReviewRoute } from '@/modules/fuel-station-reviews/fuel-station-review.routes.ts'
import { attendantReviewRoute } from '@/modules/attendant-reviews/attendant-review.routes.ts'
import { customerRoute } from '@/modules/customer/customer.routes.ts'
import { useAuthStore } from '@/modules/auth/stores/auth.store.ts'
import { authModuleRoute } from '@/modules/auth/auth.routes.ts'
import { userRoute } from '@/modules/users/user.routes.ts'
import { transactionRoute } from '@/modules/transaction/transaction.routes.ts'
import { announcementRoute } from '@/modules/announcement/announcement.routes.ts'
import { whitelistRoute } from '@/modules/whitelist/whitelist.routes.ts'
import { paymentMethodRoute } from '@/modules/payment_method/payment-method.routes.ts'
import { serviceRoute } from '@/modules/service/service.routes.ts'
import { notificationRoute } from '@/modules/notification/notification.routes.ts'
import { customerReportsRoute } from '@/modules/customer-reports/customer-reports.routes.ts'
import { transactionReportsRoute } from '@/modules/transaction-reports/transaction-reports.routes.ts'
import { voucherReportsRoute } from '@/modules/vouhcer-reports/voucher-reports.routes.ts'
import { voucherRoute } from '@/modules/voucher/voucher.routes.ts'
import { contentRoute } from '@/modules/content/content.routes.ts'
import { fuelStationsReportRoute } from '../modules/fuel-station-reviews-report/fuel-stations-report.routes.ts'
import { attendantReviewReportRoute } from '@/modules/attendant-reviews-report/attendant-reviews-report.routes.ts'
import { contentReportRoute } from '@/modules/content-report/content-report.routes.ts'
import { roleRoute } from '@/modules/role/role.routes.ts'
import { questionRoute } from '@/modules/security-questions/question.routes.ts'
import { offerRoute } from '@/modules/offer/offer.routes.ts'
import { customerTagRoute } from '@/modules/customer-tag/customer-tag.routes.ts'
import { tagRoute } from '@/modules/tags/tags.routes.ts'
import { loyaltyRoute } from '@/modules/loyalty/loyalty.routes.ts'
import { loyaltyBadgeRoute } from '@/modules/badge/loyalty-badge.routes.ts'
import { loyaltyWalletRoute } from '@/modules/loyalty-wallet/loyalty-wallet.routes.ts'
import { loyaltyCouponRoute } from '@/modules/loyalty-coupons/loyalty-coupon.routes.ts'
import { redemptionRoute } from '@/modules/redemption/redemption.routes.ts'
import { surveyRoute } from '@/modules/survey/survey.routes.ts'
import { loyaltyMegaWalletRoute } from '@/modules/loyalty-mega-wallet/loyalty-mega-wallet.routes.ts'
import { smsProviderRoute } from '@/modules/sms-provider/sms-provider.routes.ts'
import { loginHistoryRoute } from '@/modules/login-history/login-history.routes.ts'
import { loyaltyMegaWalletReportRoute } from '@/modules/loyalty-mega-wallet-report/mega-wallet-report.routes.ts'
import { loyaltyCouponsReportRoute } from '@/modules/loyalty-coupons-report/loyalty-coupons-report.routes.ts'
import { loyaltyWalletReportRoute } from '@/modules/loyalty-wallet-report/loyalty-wallet-report.routes.ts'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: AppLayout,
      children: [
        // homeModuleRoute,
        dashboardRoute,
        fuelStationRoute,
        staffRoute,
        customerRoute,
        customerTagRoute,
        voucherRoute,
        contentRoute,
        faqRoute,
        fuelTypeRoute,
        fuelStationReviewRoute,
        attendantReviewRoute,
        userRoute,
        notificationRoute,
        paymentMethodRoute,
        serviceRoute,
        smsProviderRoute,
        surveyRoute,
        transactionRoute,
        announcementRoute,
        whitelistRoute,
        customerReportsRoute,
        transactionReportsRoute,
        voucherReportsRoute,
        fuelStationsReportRoute,
        attendantReviewReportRoute,
        contentReportRoute,
        offerRoute,
        loyaltyRoute,
        loyaltyMegaWalletRoute,
        loyaltyBadgeRoute,
        loyaltyWalletRoute,
        loyaltyCouponRoute,
        roleRoute,
        redemptionRoute,
        questionRoute,
        loginHistoryRoute,
        loyaltyMegaWalletReportRoute,
        loyaltyCouponsReportRoute,
        loyaltyWalletReportRoute,
        tagRoute, // Using tags module for /tags
      ],
    },
    authModuleRoute,
  ],
})
router.beforeEach(async to => {
  const publicPages = ['/auth/login']
  const authRequired = !publicPages.includes(to.path)
  const authStore = useAuthStore()

  if (authRequired && !authStore.isLoggedIn) {
    authStore.returnUrl = to.fullPath
    return '/auth/login'
  }
})

router.afterEach(to => {
  // Remove existing meta tags
  const existingMeta = document.querySelector('meta[name="robots"]')
  if (existingMeta) existingMeta.remove()

  // Add noindex for protected routes
  if (to.meta.noIndex) {
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex, nofollow'
    document.head.appendChild(meta)
  }
})

export default router
